'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _style = require('./style.scss');

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SpinningCircle = (_dec = (0, _reactCssModules2.default)(_style2.default, { allowMultiple: true }), _dec(_class = function (_React$Component) {
  (0, _inherits3.default)(SpinningCircle, _React$Component);

  function SpinningCircle() {
    (0, _classCallCheck3.default)(this, SpinningCircle);
    return (0, _possibleConstructorReturn3.default)(this, (SpinningCircle.__proto__ || (0, _getPrototypeOf2.default)(SpinningCircle)).apply(this, arguments));
  }

  (0, _createClass3.default)(SpinningCircle, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { styleName: 'sk-fading-circle' },
        _react2.default.createElement('div', { styleName: 'sk-circle' }),
        _react2.default.createElement('div', { styleName: 'sk-circle2 sk-circle' }),
        _react2.default.createElement('div', { styleName: 'sk-circle3 sk-circle' }),
        _react2.default.createElement('div', { styleName: 'sk-circle4 sk-circle' }),
        _react2.default.createElement('div', { styleName: 'sk-circle5 sk-circle' }),
        _react2.default.createElement('div', { styleName: 'sk-circle6 sk-circle' }),
        _react2.default.createElement('div', { styleName: 'sk-circle7 sk-circle' }),
        _react2.default.createElement('div', { styleName: 'sk-circle8 sk-circle' }),
        _react2.default.createElement('div', { styleName: 'sk-circle9 sk-circle' }),
        _react2.default.createElement('div', { styleName: 'sk-circle10 sk-circle' }),
        _react2.default.createElement('div', { styleName: 'sk-circle11 sk-circle' }),
        _react2.default.createElement('div', { styleName: 'sk-circle12 sk-circle' })
      );
    }
  }]);
  return SpinningCircle;
}(_react2.default.Component)) || _class);
exports.default = SpinningCircle;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/components/SpinningCircle/index.js
// module id = 2504
// module chunks = 0